
import Request from "./requestUtil";

class RequestBuilder {
    
    constructor() {
        this.self = {
            baseUrl: "",
            headers: {},
        };
    }


    forBaseUrl() {
        this.self.baseUrl = process.env.REACT_APP_BASE_API_URL || "";
        // this.self.baseUrl = process.env.NODE_ENV === "production"
        //     ? window.location.protocol + "//" + window.location.hostname + ":" + window._env_.REACT_APP_BASE_PORT
        //     : "https://213.233.179.189" + ":" + window._env_.REACT_APP_BASE_PORT;
        return this;
    }



    withHeaders(headers) {
        this.self.headers = headers;
        return this;
    }

    build() {
        return new Request(this.self.baseUrl, this.self.headers);
    }

}

const request = new RequestBuilder();

export default request;